import { io } from "socket.io-client";
import { serverHost } from "../../../../http_common.js";
const socket = io(new URL(serverHost, window.location.origin).origin, { autoConnect: false, withCredentials: true });
let currentToken;
export const configureStaffSocket = token => {
  if (token === currentToken) { if (token && !socket.connected && !socket.active) socket.connect(); return socket; }
  currentToken = token; socket.disconnect(); socket.auth = { sessionToken: token };
  if (token) socket.connect();
  return socket;
};
export const configureStaffSocketSession=(store,expireSession)=>{
  let previous=store.getState().universeStaffs?.sessionToken;
  configureStaffSocket(previous);
  store.subscribe(()=>{const token=store.getState().universeStaffs?.sessionToken;if(token!==previous){previous=token;configureStaffSocket(token);}});
  const reject=failure=>{if((failure.status || failure.data?.status)===401){const rejectedToken=currentToken;configureStaffSocket(null);expireSession("staff",rejectedToken);}};
  socket.on("sessionRejected",reject);socket.on("connect_error",reject);
};
export const staffSocket = socket;
export const staffEmit = (event, payload = {}) => new Promise((resolve, reject) => {
  if (!socket.connected) return reject(new Error("Live connection is unavailable. Please reconnect."));
  socket.timeout(10000).emit(event, payload, (error, result) => {
    if (error) return reject(new Error("The server did not acknowledge this activity."));
    if (result?.status >= 400) return reject(new Error(result.message || "This activity could not be completed."));
    resolve(result);
  });
});
